// Vendors
import React, { createContext, useContext, useState } from 'react';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import {
  AppCheckoutOrderContextType,
  AppContextType,
  AppStateContextType,
} from './types/app.contexts.type';

const AppContext = createContext<AppContextType>({} as AppContextType);

const AppContextProvider = ({ children }: { children: React.ReactElement }): React.ReactElement => {
  const [currentState, setCurrentState] = useState<AppStateContextType>(
    AppStatesEnumeration.LOADING
  );
  const [onBackHeader, setOnBackHeader] = useState<boolean>(false);
  const [onBackClickHeader, setOnBackClickHeader] = useState<boolean>(false);
  const [checkoutOrderData, setCheckoutOrderData] = useState<AppCheckoutOrderContextType>({});
  const [statesVisited, setStatesVisited] = useState<string[]>([AppStatesEnumeration.LOADING]);

  return (
    <AppContext.Provider
      value={{
        checkoutOrderData,
        currentState,
        onBackHeader,
        onBackClickHeader,
        statesVisited,
        setCurrentState,
        setCheckoutOrderData,
        setOnBackHeader,
        setOnBackClickHeader,
        setStatesVisited,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContextConsumerHook = (): AppContextType => useContext(AppContext);

export { useAppContextConsumerHook, AppContextProvider };
